import { format } from 'date-fns';
import { nb, sv } from 'date-fns/locale';
import { getMarket } from '../../i18n';

const resolveLocale = () => {
  const marketCode = getMarket().marketCode;
  switch (marketCode) {
    case 'NO':
      return nb;
    default:
      return sv;
  }
};

export const dayMonth = (date: string | Date) =>
  format(new Date(date), 'd MMMM', { locale: resolveLocale() });

export const dateMonthYear = (date: string | Date) =>
  format(new Date(date), 'd MMMM y', { locale: resolveLocale() });

export const dayMonthYear = (date: string | Date) =>
  format(new Date(date), 'EEEE d MMMM y', { locale: resolveLocale() });
